import { render, staticRenderFns } from "./BottomGroup.vue?vue&type=template&id=25864428&scoped=true&"
import script from "./BottomGroup.vue?vue&type=script&lang=ts&"
export * from "./BottomGroup.vue?vue&type=script&lang=ts&"
import style0 from "./BottomGroup.vue?vue&type=style&index=0&id=25864428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25864428",
  null
  
)

export default component.exports